/**
 * SurveyOwnershipMixin
 *
 * Single source of truth for ESG survey ownership / read-only rules.
 *
 * Every survey document stores a numeric `createdBy` field = the cfUserId of its
 * creator. The backend sets this same value when a survey is created or
 * duplicated (it uses the requesting user's id). On the client the logged-in
 * user's cfUserId is read from the existing auth getter `getUser().id` — the
 * very same value the survey builder already writes into `createdBy` when it
 * creates surveys, headings and questions. So ownership is a direct comparison:
 *
 *   isOwner    = survey.createdBy === currentUser cfUserId
 *   isReadOnly = !isOwner          // survey created by a superadmin / someone else
 *
 * Read-only surveys are view-only; the ONLY allowed action is Copy / Duplicate.
 * Numbers are coerced defensively so a string/number mismatch never breaks the
 * comparison.
 */
export default {
  computed: {
    /** The logged-in user's cfUserId (null when it cannot be determined). */
    currentUserCfId() {
      const numericId = Number(this.$store.getters.getUser?.id);
      return Number.isFinite(numericId) ? numericId : null;
    },
  },
  methods: {
    /** True when the current user created the given survey. */
    isSurveyOwner(survey) {
      const createdBy = Number(survey?.createdBy);
      if (!Number.isFinite(createdBy) || this.currentUserCfId === null) {
        return false;
      }
      return createdBy === this.currentUserCfId;
    },
    /** True when the current user does NOT own the survey (view-only). */
    isSurveyReadOnly(survey) {
      return !this.isSurveyOwner(survey);
    },
  },
};
